export default "__VITE_ASSET__Djj9$HRp__"